import React from "react";
import AnalyticsStatHero, { formatInr } from "./AnalyticsStatHero";

/** Tab header: total = bank + cash with breakdown. */
export default function MonthlyBankCashHero({
  label,
  periodMonth,
  bankRupee = 0,
  cashRupee = 0,
  valueClassName = "text-warning",
  extraMeta,
}) {
  const bank = Number(bankRupee) || 0;
  const cash = Number(cashRupee) || 0;
  const total = bank + cash;
  const heroLabel = periodMonth ? `${label} — ${periodMonth}` : label;

  return (
    <AnalyticsStatHero
      label={heroLabel}
      amountRupee={total}
      valueClassName={valueClassName}
      meta={
        <>
          <div>
            Bank: <strong className="text-light">{formatInr(bank)}</strong>
          </div>
          <div>
            Cash: <strong className={cash > 0 ? "text-warning" : "text-secondary"}>{formatInr(cash)}</strong>
          </div>
          {extraMeta}
        </>
      }
    />
  );
}
